export default class BlockLeagueScores {
    constructor(container, options) {
        const defaultOptions = {
            viewScoreButton: '.btn-viewscore',
            venue: '.venue'
        };

        this.options = Object.assign({}, defaultOptions, options);
        this.container = document.querySelector(container);
        this.viewScoreButton = this.container.querySelector(this.options.viewScoreButton);
        this.venues = this.container.querySelectorAll(this.options.venue);
        this.redirectUrl = '';

        this.setEvents();
    }

    setEvents() {
        this.viewScoreButton.addEventListener('click', this.redirectToScorePage.bind(this));
    
        this.venues.forEach(venue => {
            venue.addEventListener('click', (elem) => this.enableDisableButton(elem));
        }) 
    }

    redirectToScorePage() {
        if (this.redirectUrl === '') {
            return;
        }
        
        window.open(this.redirectUrl, "_blank");
    }
    
    getBlockLeagueScoresLink(venue) {
        return venue.dataset.leaguescorelink;
    }

    enableDisableButton(elem){
        this.redirectUrl = this.getBlockLeagueScoresLink(elem.target);
        this.viewScoreButton.disabled = this.redirectUrl === '';
    }
}